import { render } from "./RegistrationTabsComponent.vue?vue&type=template&id=1f15882d&scoped=true"
import script from "./RegistrationTabsComponent.vue?vue&type=script&lang=js"
export * from "./RegistrationTabsComponent.vue?vue&type=script&lang=js"

import "./RegistrationTabsComponent.vue?vue&type=style&index=0&id=1f15882d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f15882d"]])

export default __exports__